import { render, staticRenderFns } from "./AfterLoginSelector.vue?vue&type=template&id=addf605c&scoped=true&"
import script from "./AfterLoginSelector.vue?vue&type=script&lang=ts&"
export * from "./AfterLoginSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AfterLoginSelector.vue?vue&type=style&index=0&id=addf605c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addf605c",
  null
  
)

export default component.exports